function UserHeartIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_878_1137)">
				<path
					d="M4 21V19C4 17.9391 4.42143 16.9217 5.17157 16.1716C5.92172 15.4214 6.93913 15 8 15H9"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13 16.9451C13 16.5527 13.1182 16.1695 13.3388 15.8462C13.5595 15.5229 13.8724 15.2746 14.2361 15.1342C14.5997 14.9938 14.9971 14.9678 15.3758 15.0597C15.7544 15.1516 16.0965 15.357 16.3568 15.6489C16.3752 15.6686 16.3973 15.6844 16.422 15.6951C16.4466 15.7059 16.4731 15.7114 16.5 15.7114C16.5268 15.7114 16.5534 15.7059 16.578 15.6951C16.6026 15.6844 16.6248 15.6686 16.6431 15.6489C16.9026 15.3551 17.2448 15.1479 17.6241 15.0549C18.0033 14.9619 18.4017 14.9875 18.7662 15.1282C19.1307 15.269 19.444 15.5182 19.6644 15.8428C19.8848 16.1673 20.0018 16.5518 20 16.9451C20 17.7525 19.475 18.3555 18.95 18.8844L17.0278 20.7579C16.9626 20.8333 16.8822 20.8939 16.7919 20.9357C16.7016 20.9774 16.6036 20.9994 16.5043 21C16.405 21.0006 16.3067 20.98 16.2159 20.9394C16.1251 20.8988 16.044 20.8392 15.9778 20.7646L14.05 18.8844C13.525 18.3555 13 17.7561 13 16.9451Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_878_1137">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default UserHeartIcon;
